import dashboardService from '../service/dashboard'


const state = {
    defineAlarm: {
        data: "",
        loading: false
    },
    pointHealth: {
        data: [],
        loading: false
    },
    alarmOccurence: {
        data: "",
        loading: false
    },
    pointRecovery: {
        data: "",
        loading: false
    },
    alarmTransactions: {
        data: "",
        loading: false
    },
    pointHealthScore: {
        data: "",
        loading: false
    }

}

const actions = {
    getdefineAlarm({ commit }) {
        dashboardService.getdefineAlarm().then(m => {
            commit('setdefineAlarmLoading', true)
            commit('setdefineAlarm', m)
            return m;
        }).catch((e) => {
            console.log("dashboard", e)
        }).finally(() => {
            commit('setdefineAlarmLoading', false)
        })
    },
    getPointHealth({ commit }) {
        dashboardService.getPointHealth().then(m => {
            commit('setPointHealthLoading', true)
            commit('setPointHealth', m)
            return m;
        }).catch((e) => {
            console.log("dashboard", e)
        }).finally(() => {
            commit('setPointHealthLoading', false)
        })
    },
    getAlarmOccurence({ commit }, { dayCount, unit, filteredPoints }) {
        dashboardService.getAlarmOccurence(dayCount, unit, filteredPoints).then(m => {
            commit('setAlarmOccurenceLoading', true)
            commit('setAlarmOccurence', m)
            return m;
        }).catch((e) => {
            console.log(e)
        }).finally(() => {
            commit('setAlarmOccurenceLoading', false)
        })
    },
    getPointRecovery({ commit }) {
        dashboardService.getPointRecovery().then(m => {
            commit('setPointRecoveryLoading', true)
            commit('setPointRecovery', m)
            return m;
        }).catch((e) => {
            console.log(e)
        }).finally(() => {
            commit('setPointRecoveryLoading', false)
        })
    },
    getAlarmTransactions({ commit }, { pageSize, pageNumber, filteredPoints, levelName }) {
        dashboardService.getAlarmTransactions(pageSize, pageNumber, filteredPoints, levelName).then(m => {
            commit('setAlarmTransactionsLoading', true)
            commit('setAlarmTransactions', m)
            return m;
        }).catch((e) => {
            console.log("dashboard", e)
        }).finally(() => {
            commit('setAlarmTransactionsLoading', false)
        })
    },
    getPointHealthScore({ commit }) {
        dashboardService.getPointHealthScore().then(m => {
            commit('setPointHealthScoreLoading', true)
            commit('setPointHealthScore', m)
            return m;
        }).catch((e) => {
            console.log("dashboard", e)
        }).finally(() => {
            commit('setPointHealthScoreLoading', false)
        })
    },

}

const mutations = {
    setdefineAlarmLoading(state, loading) {
        state.defineAlarm.loading = loading
    },
    setdefineAlarm(state, res) {
        state.defineAlarm.data = res;
        state.defineAlarm.loading = false
    },
    setPointHealthLoading(state, loading) {
        state.pointHealth.loading = loading
    },
    setPointHealth(state, res) {
        state.pointHealth.data = res;
        state.pointHealth.loading = false
    },
    setAlarmOccurenceLoading(state, loading) {
        state.alarmOccurence.loading = loading
    },
    setAlarmOccurence(state, res) {
        state.alarmOccurence.data = res;
        state.alarmOccurence.loading = false
    },
    setPointRecoveryLoading(state, loading) {
        state.pointRecovery.loading = loading
    },
    setPointRecovery(state, res) {
        state.pointRecovery.data = res;
        state.pointRecovery.loading = false
    },
    setAlarmTransactionsLoading(state, loading) {
        state.pointRecovery.loading = loading
    },
    setAlarmTransactions(state, res) {
        state.alarmTransactions.data = res;
        state.alarmTransactions.loading = false
    },
    setPointHealthScoreLoading(state, loading) {
        state.pointHealthScore.loading = loading
    },
    setPointHealthScore(state, res) {
        state.pointHealthScore.data = res;
        state.pointHealthScore.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



